import { Injectable } from '@angular/core';
import { SharedConstants } from '@formbird/types';
import { RuleHelper } from '@formbird/shared';
import { ClientRulesService } from './client-rules.service';
import { ConfigService } from '../config/config.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { LocalStorageKeys } from '../../constants/LocalStorageKeys';
import { DocumentSessionService } from '../document/document-session.service';

const logger = console;

@Injectable({
  providedIn: 'root'
})
export class RuleEngineService {

  constructor(
    private clientRulesService: ClientRulesService,
    private configService: ConfigService,
    private localStorageService: LocalStorageService,
    private documentSessionService: DocumentSessionService
  ) {
  }

  /*
   * Process Rule flow string
   * @document - document object
   * @documentContext - additional objects will be used in rules
   * @ruleFlowString - rules flow as string
   * @scope - additional scope objects will be plugged in to rules scope
   */

  async processRuleFlow(document, documentContext, ruleFlowString, ruleScope, callback) {

    const _self = this;

    const thisScope = await this.clientRulesService.expose();

    if (ruleScope) {

      Object.keys(thisScope).forEach(function(key) {
        ruleScope[key] = thisScope[key];
      });

      if (!documentContext) {
        documentContext = {};
      }

      documentContext.logger = logger;
      documentContext.appVersion = _self.localStorageService.getItem(LocalStorageKeys.APP_VERSION);
      documentContext.databaseMode = _self.configService.clientConfig().defaultSearchProvider;
      documentContext.documentSession = this.documentSessionService.getDocumentSession(document.documentId);

      _self.clientRulesService.addIncludesToRuleset(ruleFlowString, function(processedRuleFlowResult) {

        if (processedRuleFlowResult.status === SharedConstants.STATUS_ERROR) {
          callback(processedRuleFlowResult);
        } else {
          const processedRuleFlow = processedRuleFlowResult.ruleFlow;
          if (processedRuleFlow) {
              // Parse the rulesetScript into a JSON object of functions
              const ruleset = Function('return (' + processedRuleFlow + ')')();
              RuleHelper.processJsonRuleset(document, documentContext, ruleset, ruleScope,
                function(result) {
                  _self.documentSessionService.setDocumentSession(document.documentId, documentContext.documentSession);
                  callback(result);
                });
          } else {
            callback();
          }
        }
      });
    }
  }

}
